module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-11-b660ad7b946a6c5a85dca717fa0806a9.png";